import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import GetTasks from '../../api/task/get_tasks';
import CheckCookie from '../../api/user/user';
import Loader from '../../components/loader/loader';
import './profile.css';
import {Chip, Button} from '@material-ui/core';
import SubjectIcon from '@material-ui/icons/Subject';
import VerifiedIcon from '@mui/icons-material/Verified';
import UpdateUserDialog from '../../components/update user dialog/update_user_dialog';

const Profile = ()=>{

    const [visible_loader, setVisibleLoader] = useState(false);
    const [user_data, setUserData] = useState({});
    const [task_data, setTaskData] = useState([]);
    const [visibleUpdateUserDialog, setVisibleUpdateUserDialog] = useState(false);

    useEffect(()=>{
        setVisibleLoader(true);
        CheckCookie({}, (res)=>{
            console.log("Printing response of the loggedin user data in profile", res);
            setVisibleLoader(false);
            if(res.data.status){
                setUserData(res.data.data[0]);
            }
        }, (err)=>{
            console.log(err);
        })
        setVisibleLoader(true);
        GetTasks({}, (res)=>{
            console.log("Printing response of the loggedin user's assigned task", res);
            setVisibleLoader(false);
            if(res.data.status){
                if(res.data.data.length > 4){
                    let temp_arr = new Array();
                    res.data.data.reverse().map((v,i)=>{
                        i<=3 && temp_arr.push(v);
                    })
                    setTaskData(temp_arr);
                }
                else{
                    setTaskData(res.data.data);
                }
            }
        }, (err)=>{
            console.log(err);
        })
    }, [])

    return (
        <>
            {visibleUpdateUserDialog === true && <UpdateUserDialog closeDialog={(reload)=>{setVisibleUpdateUserDialog(false); reload === true && window.location.reload()}} />}
            {visible_loader === true && <Loader />}
            <div className="profile">
                <div className="box">
                    <div className="user_details">
                        <div className="left_section">
                            <h1 className="name">{user_data?.first_name} {user_data?.last_name}{user_data?.admin === true && <VerifiedIcon style={{color: "#4f62dd"}} />}</h1>
                            <h3>Email Address: {user_data?.email}</h3>
                            <h4>Phone Number: {user_data?.phone}</h4>
                        </div>
                        <div className='right_section'>
                            <Button onClick={()=>{setVisibleUpdateUserDialog(true)}}>Edit Profile</Button>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <div className="task_details">
                        {console.log(task_data.reverse())}
                        {
                            task_data?.map((value)=>{
                                return <div className="card">
                                    <h2 style={{fontSize: '25px'}}>{value?.title}</h2>
                                    <div style={{display: "flex", alignItems: 'center', flexWrap: 'wrap'}}>
                                        {value.description !== "" ? <SubjectIcon /> : null}
                                        {
                                            value?.status === "Not Started" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#16a085", color: "#fff"}}></Button>
                                        }
                                        {
                                            value?.status === "Development" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#e67e22", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Error" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#e74c3c", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "QC" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#2980b9", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Reference" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#34495e", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.status === "Completed" && <Button style={{textTransform: "capitalize", fontSize: "18px", height: "15px", width: "20px", borderRadius: "20px", backgroundColor: "#27ae60", color: '#fff'}}></Button>
                                        }
                                        {
                                            value?.assigned.map((v)=>{
                                                return <Chip label={v} variant="default" style={{margin: "0 5px"}} />
                                            })
                                        }
                                        </div>
                                </div>
                            })
                        }
                        {task_data?.length >= 4 && <Button style={{margin: "10px auto", background: "#4f62dd", color:'#fff', fontSize: "22px", textTransform: 'capitalize'}}><Link to="/tasks" style={{textDecoration: 'none', color: '#fff'}}>View More</Link></Button>}
                    </div>
                </div>
            </div>
        </>
    )
};

export default Profile;